// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2zkTR","top":"style_top__1pmoa","title":"style_title__3EGx2","text":"style_text__2uuEP"};